// AnsBelowQues.jsx

import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchBankAndAmountData } from '../../Actions/creditExperianHistoryAction';
import Loader from '../Common/loader';
import { toast } from 'react-toastify';

const AnsBelowQues = (props) => {
    const [selectedBank, setSelectedBank] = useState('');
    const [selectedAmount, setSelectedAmount] = useState('');
    const {question, banks, amounts, qid, error, loading} = useSelector((state) => state.questionAnswer);
    const dispatch = useDispatch();

    const {handleLastQuesSubmitExperian, handleNoQuestionFetched} = props;

    useEffect(() => {
        let payload = {
            type: "GET_VERIFY_ANSWERS", // Updated API type
            question: "1", // Assuming question ID 1 is for bank and amount
            answer: "0", // Default answer
        }
        dispatch(fetchBankAndAmountData(payload, skipQuesCallback));
    }, []);

    const skipQuesCallback = (result, payload) => {
        if(result && result?.msg){
            if(result?.msg == 'We are unable to deliver your report through this channel due to a very large number of accounts.'){
              payload.type = 'SKIP_CREDIT_OTP'  
            //   toast.error("Something went wrong" , {
            //     position: "top-right",
            //     autoClose: 5000,
            //     hideProgressBar: false,
            //     closeOnClick: true,
            //     pauseOnHover: true,
            //     draggable: true,
            //     progress: undefined,
            //   });   
              dispatch(fetchBankAndAmountData(payload));
              handleNoQuestionFetched(result)
            }
            if(result?.msg == "Questions" && (result?.data?.qid == null || result?.data?.question == null)){
              payload.type = 'SKIP_CREDIT_OTP'
            //   toast.error("Something went wrong" , {
            //     position: "top-right",
            //     autoClose: 5000,
            //     hideProgressBar: false,
            //     closeOnClick: true,
            //     pauseOnHover: true,
            //     draggable: true,
            //     progress: undefined,
            //   });
              dispatch(fetchBankAndAmountData(payload));
              handleNoQuestionFetched(result)
            }
          }
    }

    // useEffect(() => {
    //     if(error?.msg) {
    //         handleLastQuesSubmitExperian("error");
    //     }
    // },[error])

    // const banks = useSelector((state) => state.phoneNumbers.banks);
    // const amounts = useSelector((state) => state.phoneNumbers.amounts);
    // const {question, banks, amounts, qid, error} = useSelector((state) => state.questionAnswer);
    // const amounts = useSelector((state) => state.questionAnswer?.amounts ?? []);

    const handleBankChange = (event) => {
        setSelectedBank(event.target.value);
    };

    const handleAmountChange = (event) => {
        setSelectedAmount(event.target.value);
    };

    const handleVerifyClick = async (e) => {
        // console.log('Submitted bank:', selectedBank);
        // console.log('Submitted amount:', selectedAmount);
        e?.preventDefault();
        const optionSet1AnsIndex = banks?.indexOf(selectedBank);
        const optionSet2AnsIndex = amounts?.indexOf(selectedAmount);
        let verifyPayload = {
          type: "GET_VERIFY_ANSWERS", // Updated API type
          question: "0",
          answer: "1",
          "questionid" : qid,
          "answer1": selectedBank,
          "answer2": selectedAmount
        };

        const failedVerification = {
            "success": 0,
            "type": "GET_VERIFY_ANSWERS",
            "data": "",
            "msg": {
                "msg": "Thanks for your time. Unfortunately identity authentication was unsuccessful."
            },
            "api": 1,
            "CREDIT_BUREAU": "Experian"
        }
        await dispatch(fetchBankAndAmountData(verifyPayload, handleLastResponseCase));
        setSelectedAmount('');
        setSelectedBank('');
    };

    const handleLastResponseCase = (result) => {
            handleLastQuesSubmitExperian(result);
    }

    return (
        <>
         {loading && <Loader />} 
         <div className='mt-3'>
            <h6 style={{ fontSize: "20px", fontWeight: "600", lineHeight: "30px", textAlign: "left", color: "#101828" }}>Answer below question:</h6>
            <p style={{ fontSize: "18px", fontWeight: "400", lineHeight: "21.24px", textAlign: "left", color: "#101828" }}>
                {question}
            </p>
            <div className="option-set py-2">
                <h6 style={{ fontSize: "18px", fontWeight: "400", lineHeight: "24px", textAlign: "left", color: "#101828" }}>Option set 1</h6>
                {banks.map((bank, index) => (
                    <div key={index} className="form-check">
                        <input
                            className="form-check-input"
                            style={{
                                width: "20px",
                                height: "20px",
                            }}
                            type="radio"
                            name="bankRadios"
                            id={`bankRadio${index}`}
                            value={bank}
                            checked={selectedBank === bank}
                            onChange={handleBankChange}
                        />
                        <label className="form-check-label" htmlFor={`bankRadio${index}`} style={{
                            padding: "3px 9px",
                        }}>{bank}</label>
                    </div>
                ))}
            </div>
            <div className="option-set py-2">
                <h6 style={{ fontSize: "18px", fontWeight: "400", lineHeight: "24px", textAlign: "left", color: "#101828" }}>Option set 2</h6>
                {amounts.map((amount, index) => (
                    <div key={index} className="form-check">
                        <input
                            className="form-check-input"
                            style={{
                                width: "20px",
                                height: "20px",
                            }}
                            type="radio"
                            name="amountRadios"
                            id={`amountRadio${index}`}
                            value={amount}
                            checked={selectedAmount === amount}
                            onChange={handleAmountChange}
                        />
                        <label className="form-check-label" htmlFor={`amountRadio${index}`} style={{
                            padding: "3px 9px",
                        }}>{amount}</label>
                    </div>
                ))}
            </div>
            <div className="btn-box d-flex justify-content-between w-100 h-100 p-1 pt-3" style={{ maxWidth: "422px", }}>
                <button className="btn w-100 btn-primary text-light"  disabled = {!(selectedAmount && selectedBank)}onClick={(e) => handleVerifyClick(e)} style={{ cursor: "pointer" }}>Submit</button>
            </div>
        </div>
        </>
    );
};

export default AnsBelowQues;
